// Auto generated file, do not manually modify!
// com.hotpads.clientappconfig.web.handler.web.ClientAppConfigWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

interface GetAllFeaturesParams {
  appName: string;
}
interface GetFeatureParams {
  appName: string;
  featureName: string;
}

export const ClientAppConfigWebApiHandler_getAllFeatures_Path = '/api/web/v1/appConfig/getAllFeatures';

/**
 * Get all app configuration for an application
 */
export const ClientAppConfigWebApiHandler_getAllFeatures = (
  getParams: GetAllFeaturesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetAllFeaturesParams, never, Record<string, string>>({
    getParams: getParams,
    endpoint: ClientAppConfigWebApiHandler_getAllFeatures_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const ClientAppConfigWebApiHandler_getFeature_Path = '/api/web/v1/appConfig/getFeature';

/**
 * Get app configuration feature for an application
 */
export const ClientAppConfigWebApiHandler_getFeature = (
  getParams: GetFeatureParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetFeatureParams, never, string>({
    getParams: getParams,
    endpoint: ClientAppConfigWebApiHandler_getFeature_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
